import { Button, CssBaseline, makeStyles, Typography, List, ListItem, Box, Checkbox } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';
import ToastStr from '../../request/toastStr';
import { SubAdminHeaderBar } from '../../shared/header/HeaderBar';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		//gridTemplateColumns: '230px 1fr',
	},
	mainPage: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5vh',
	},
	classList: {
		'& #classOpen': {
			float: 'right',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		borderBottom: '2px solid black',
		//borderRadius: '10px 10px 0 10px',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '1fr 3fr 5fr 3fr 3fr 2fr  17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			//background: 'none',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '1fr 3fr 5fr 3fr 3fr 2fr 17px',
		padding: '25px 0',
		//backgroundColor: `${COLORS.LIGHT_GREY}`,
		backgroundColor: `${COLORS.WHITE}`,
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: 'none',
		fontSize: '1rem',
		fontFamily: 'NanumB',
		//fontWeight: 'bold',
		lineHeight: '21px',
		bolderWidth: '1px',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
	operApprove: {
		float: 'right',
		margin: '5px 3%',
		padding: '5px 25px',
		color: `${COLORS.WHITE}`,
		borderRadius: '5px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			color: `${COLORS.WATER_BLUE}`,
			backgroundColor: 'inherit',
		},
	},
	operDelete: {
		float: 'right',
		margin: '5px 3%',
		padding: '5px 25px',
		color: `${COLORS.WHITE}`,
		borderRadius: '5px',
		backgroundColor: `#f50057`,
		'&:hover': {
			color: `#f50057`,
			backgroundColor: 'inherit',
		},
	},
}));

type iOperList = {
	operator_email: string;
	operator_name: string;
	operator_phone: string;
	join_date: string;
	approve: boolean;
	affiliation: string;
};

const SERVER = basic.server;

const SubAdminOperList: React.FC<any> = (props) => {
	const classes = useStyles();

	const [ClassList, setClassList] = useState<iOperList[]>([]);
	const [checkedCodes, setCheckedCodes] = useState<String[]>([]);
	const { enqueueSnackbar } = useSnackbar();
	const [page, setPage] = useState(1);
	const loader = useRef(null);

	const postOperApprove = () => {
		if (checkedCodes === undefined || checkedCodes.length === 0)
			enqueueSnackbar(ToastStr.OPER_CHECKED_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		else {
			axios({
				method: 'POST',
				data: {
					oper_emails: checkedCodes,
				},
				withCredentials: true,
				url: SERVER + v_admin.admin + v_admin.oper_approval,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					console.log(data.code);
					if (data.code == Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.OPER_APPROVE_SUCCESS_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.OPER_APPROVE_FAIL_STR, {
								variant: 'warning',
								autoHideDuration: SNACKBAR_TIME,
							});
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
								variant: 'error',
								autoHideDuration: SNACKBAR_TIME,
							});
						}
					}
				})
				.then(() => {
					setPage(1);
					getOperList(1);
					setCheckedCodes([]);
				});
		}
	};

	const postOperDelete = () => {
		if (checkedCodes === undefined || checkedCodes.length === 0)
			enqueueSnackbar(ToastStr.OPER_CHECKED_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		else {
			axios({
				method: 'POST',
				data: {
					oper_emails: checkedCodes,
				},
				withCredentials: true,
				url: SERVER + v_admin.admin + v_admin.oper_delete,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					console.log(data.code);
					if (data.code == Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.OPER_DELETE_SUCCESS_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.OPER_DELETE_FAIL_STR, {
								variant: 'warning',
								autoHideDuration: SNACKBAR_TIME,
							});
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
								variant: 'error',
								autoHideDuration: SNACKBAR_TIME,
							});
						}
					}
				})
				.then(() => {
					setPage(1);
					getOperList(1);
					setCheckedCodes([]);
				});
		}
	};

	const getOperList = (page: number) => {
		let url = new URL(SERVER + v_admin.admin + v_admin.oper_list);
		url.searchParams.append('page', String(page));
		url.searchParams.append('limit', '30');
		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					if (page === 1) setClassList(data.data);
					else {
						setClassList((prevClassList) => [...prevClassList, ...data.data]);
					}
				}
			});
	};

	const handleCheckboxChange = (email: String, isChecked: boolean) => {
		setCheckedCodes((prev: any) => {
			if (isChecked) {
				return [...prev, email];
			} else {
				return prev.filter((code: String) => code !== email);
			}
		});
	};

	const handleObserver = useCallback((entries: any) => {
		const target = entries[0];
		if (target.isIntersecting) {
			setPage((prevState) => {
				if (prevState + 1 > 999) {
					return prevState;
				}
				return prevState + 1;
			});
		}
	}, []);

	useEffect(() => {
		const setLoader = () => {
			const option = {
				root: null,
				rootMargin: '20px',
				threshold: 0,
			};
			// console.log('in infinite useEffect')
			const observer = new IntersectionObserver(handleObserver, option);
			if (loader.current) observer.observe(loader.current!);
		};
		setTimeout(() => setLoader(), 100);
	}, [handleObserver]);

	useEffect(() => {
		getOperList(page);
	}, [page]);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<SubAdminHeaderBar />
					<div className={classes.classList}>
						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography></Typography>
								</span>
								<span>
									<Typography>강사 이름</Typography>
								</span>
								<span>
									<Typography>등록 메일</Typography>
								</span>
								<span>
									<Typography>전화 번호</Typography>
								</span>
								<span>
									<Typography>소속</Typography>
								</span>
								<span>
									<Typography>승인 여부</Typography>
								</span>
							</div>
							<List id="classinfo">
								{ClassList != null &&
									ClassList.map((item: any, index: number) => {
										return (
											<AppListItem
												index={index}
												name={item.operator_name}
												email={item.operator_email}
												phone={item.operator_phone}
												//date={item.join_date.slice(2, 10)}
												approve={item.approve}
												affiliation={item.affiliation}
												checked={checkedCodes.includes(item.operator_email)}
												onCheckboxChange={handleCheckboxChange}
											/>
										);
									})}
								<div className={classes.blank} ref={loader}></div>
							</List>
						</div>
						<Button className={classes.operDelete} onClick={postOperDelete}>
							<Typography>관리자 삭제</Typography>
						</Button>
						<Button className={classes.operApprove} onClick={postOperApprove}>
							<Typography>관리자 승인</Typography>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, name, email, phone, affiliation, approve, checked } = props;
	const [isChecked, setIsChecked] = useState(checked);

	useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	const handleCheckboxChange = (event: any) => {
		setIsChecked(event.target.checked);
		props.onCheckboxChange(email, event.target.checked);
	};

	return (
		<ListItem id={index} className={classes.classInfo}>
			<Checkbox checked={isChecked} onChange={handleCheckboxChange} inputProps={{ 'aria-label': 'primary checkbox' }} />
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{email}</Box>
			<Box className={classes.buttonLabel}>{phone}</Box>
			<Box className={classes.buttonLabel}>{affiliation === null ? '미등록' : affiliation}</Box>
			<Box className={classes.buttonLabel} style={{ color: approve ? '#1291d9' : '#f50057' }}>
				{approve ? '승인 완료' : '대기 중'}
			</Box>
		</ListItem>
	);
};

export default SubAdminOperList;
